import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { DevicesFilterOption } from '../models/device-filter-option';
import { DeviceRegisterListItem } from '../models/device-register-results.model';

const area = 'Device Register';
export const deviceRegisterAdapterActions = createRegisterActions<DeviceRegisterListItem>(area);

export const createDevice = createAction(`[${area}] Create Device`);

export const deviceRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: DevicesFilterOption[] }>()
);

export const loadSystemDevicesSuccess = createAction(`[System ${area}] Register Load Success`);

export const loadAccountDevicesSuccess = createAction(`[Account ${area}] Register Load Success`);

export const changeSipUserPasswords = createAction(
   `[${area}] Change Sip User Passwords`,
   props<{ sipUserIds: number[] }>()
);

export const changeSipUserPasswordSuccess = createAction(`[${area}] Change Sip User Password Success`);

export const changeSipUserPasswordFailure = createAction(
   `[${area}] Change Sip User Password Failure`,
   props<SingleGraphError>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);

export const rebootPhone = createAction(`[${area}] Reboot Phone`, props<{ deviceId: number }>());

export const rebootPhoneSuccess = createAction(`[${area}] Reboot Phone Success`);

export const rebootPhoneFailure = createAction(`[${area}] Reboot Phone Failure`, props<SingleGraphError>());

export const resetPhoneZtp = createAction(`[${area}] Factory Reset Phone Ztp`, props<{ deviceId: number }>());

export const resetPhoneZtpSuccess = createAction(`[${area}] Factory Reset Phone Ztp Success`);

export const resetPhoneZtpFailure = createAction(
   `[${area}] Factory Reset Phone Ztp Failure`,
   props<SingleGraphError>()
);
